// extracted by mini-css-extract-plugin
export default {"drawer":"add-edit-rooms_drawer__4XoGn","footerWrapper":"add-edit-rooms_footerWrapper__I7luB","footerBackButton":"add-edit-rooms_footerBackButton__8mA9-"};